// TODO: migrate to ./store.js
export default {
	store_updateMeetingTopicError: "An error occurred while updating a topic: {message}",
	store_createMeetingTopicError: "An error occurred while creating a topic: {message}",
	store_reSortTopicsError: "An error occurred while re-ordering topics: {message}",
	store_deferTopicError: "An error occurred while deferring a topic: {message}",
	store_undeferTopicError: "An error occurred while un-deferring a topic: {message}",
	store_pinTopicError: "An error occurred while pinning a topic: {message}",
	store_unpinTopicError: "An error occurred while un-pinning a topic: {message}",
	store_removeTopicError: "An error occurred while removing a topic: {message}",
	store_tooManyOutcomesError: "A topic with outcomes cannot be removed. The Outcomes should be removed first.",
	store_reSyncError: "An error occurred while trying to re-sync your schedule: {message}",
	store_refreshScheduleError: "An error occurred refreshing the schedule: {message}",
	store_assignTeamToMeetingError: "An error occurred while assigning the team to your meeting: {message}",
	store_unassignTeamFromMeetingError: "An error occurred while unassigning the team from your meeting: {message}",
	store_loadMeetingGoalsError: "An error occurred while loading meeting goals: {message}",
	store_missingCommitmentError: "The action item specified could not be found",
	store_filterOption_allMeetings: "All meetings",
	store_filterOption_teamMeetings: "Team meetings",
	store_filterOption_oneOnOneMeetings: "1:1 meetings",
	store_filterOption_noTopicMeetings: "Meetings with no topics",
	store_filterOption_noTeamMeetings: "Meetings with no team assigned",
	store_persistableFilterOption_showAllDay: "Show all-day events",
	store_persistableFilterOption_showOnlyMe: "Show events with only me",
	store_persistableFilterOption_showHidden: "Show meetings I've hidden",
};



// WEBPACK FOOTER //
// ./src/lang/en/scheduleStore.js